import { render, staticRenderFns } from "./ReceiptRow.vue?vue&type=template&id=680dce05&"
import script from "./ReceiptRow.vue?vue&type=script&lang=js&"
export * from "./ReceiptRow.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680dce05')) {
      api.createRecord('680dce05', component.options)
    } else {
      api.reload('680dce05', component.options)
    }
    module.hot.accept("./ReceiptRow.vue?vue&type=template&id=680dce05&", function () {
      api.rerender('680dce05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptRow.vue"
export default component.exports